import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AddToBagButton from "components/source/reservations/add-to-bag-button";
import { HEAP_ADD_TO_BAG_IDS } from "helpers/heap-helpers";

class AddToBagButtonWrapper extends React.Component {
  static propTypes = {
    isBulk: PropTypes.bool,
    isClearance: PropTypes.bool,
    isExistingHold: PropTypes.bool,
    isMobile: PropTypes.bool,
    isOneSize: PropTypes.bool.isRequired,
    isRentable: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    price: PropTypes.shape({
      minimumFormatted: PropTypes.string,
      maximumFormatted: PropTypes.string,
    }),
  };

  static defaultProps = {
    isSubmitting: false, // safer default so we show an enabled button
    isExistingHold: false,
    isMobile: true,
  };

  isDisabled() {
    const { isExistingHold, isRentable, isOneSize, isSubmitting } = this.props;
    // return true if form is submitting
    // or if we are editing a one-size saleable order
    const isEditingOneSizeSaleable = isExistingHold && !isRentable && isOneSize;
    return Boolean(isSubmitting || isEditingOneSizeSaleable);
  }

  getHeapId() {
    const { isBulk, isClearance, isExistingHold, isRentable } = this.props;

    if (isExistingHold) return;

    if (isBulk) {
      return HEAP_ADD_TO_BAG_IDS.SALEABLE;
    } else if (isClearance) {
      return HEAP_ADD_TO_BAG_IDS.CLEARANCE;
    } else if (isRentable) {
      return HEAP_ADD_TO_BAG_IDS.RESERVE;
    }
  }

  getCopy() {
    const { isExistingHold } = this.props;

    if (isExistingHold) {
      return this.getEditReservationCopy();
    }
    return this.getNewReservationCopy();
  }

  getEditReservationCopy() {
    const { isRentable, isSubmitting } = this.props;

    if (isRentable) {
      return isSubmitting ? "Updating…" : "Update Reservation";
    }
    return this.getEditSaleableCopy();
  }

  getEditSaleableCopy() {
    const { isOneSize, isSubmitting } = this.props;

    if (isOneSize) {
      return "Added to Bag"; // this button is disabled and has no submitting state
    }
    return isSubmitting ? "Updating…" : "Update Item";
  }

  getNewReservationCopy() {
    const { isMobile, isRentable, isSubmitting } = this.props;
    // new reservation copy is always the same except for desktop rentals
    if (isRentable && !isMobile) {
      return isSubmitting ? "Reserving" : "Add to Bag";
    }
    return isSubmitting ? "Adding" : "Add to Bag";
  }

  render() {
    return (
      <AddToBagButton
        buttonCopy={this.getCopy()}
        disabled={this.isDisabled()}
        loading={this.props.isSubmitting}
        isMobile={this.props.isMobile}
        dataHeapId={this.getHeapId()}
      />
    );
  }
}

const mapStateToProps = ({ isSubmitting }) => ({ isSubmitting });

export default connect(mapStateToProps)(AddToBagButtonWrapper);
